<template>
    <div class="product-add">
        <!--form表单-->
        <el-form size="small" ref="form" :model="form" label-width="200px">
            <!--添加店员-->
            <div class="common-form">{{$t('商家信息')}}</div>
            <el-form-item style="margin-bottom: 30px" :label="$t('商家店名')" prop="supplier.name" :rules="[{required: true,message: $t('请输入商家店名')}]">
                <el-input class="max-w460" v-model="form.supplier.name" :placeholder="$t('请输入商家店名')"></el-input>
                <div class="form-item-hint">{{$t('请按实际店名填写，将显示在商家点餐网站上')}}</div>
            </el-form-item>
            <el-form-item :label="$t('联系人')" prop="supplier.link_name" :rules="[{required: true,message: $t('请输入联系人')}]">
              <el-input class="max-w460" v-model="form.supplier.link_name" :placeholder="$t('请输入联系人')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('联系电话')" prop="supplier.link_phone" :rules="[{required: true,message: $t('请输入联系电话')}]">
              <el-input class="max-w460" v-model="form.supplier.link_phone" :placeholder="$t('请输入联系电话')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('门店logo')">
              <el-row>
                <el-button icon="el-icon-picture-outline" @click="openUpload('logo')">{{$t('选择图片')}}</el-button>
                <div v-if="form.supplier.logo != ''" class="img">
                  <img :src="form.supplier.logo" width="100" height="100"/>
                </div>
              </el-row>
            </el-form-item>
<!--            <el-form-item :label="$t('账号')" prop="supplier.user_name" :rules="[{required: true,message: ' '}]">-->
<!--                <el-input :disabled="form.supplier.is_main==1" class="max-w460" v-model="form.supplier.user_name"-->
<!--                          :placeholder="$t('请输入账号')"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item :label="$t('登录密码')" prop="supplier.password">-->
<!--                <el-input v-model="form.supplier.password" :placeholder="$t('请输入登录密码')" type="password"-->
<!--                          class="max-w460"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item :label="$t('确认密码')" prop="supplier.confirm_password">-->
<!--                <el-input v-model="form.supplier.confirm_password" :placeholder="$t('请输入确认密码')" type="password"-->
<!--                          class="max-w460">-->
<!--                </el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item :label="$t('店铺类型')">-->
<!--                <el-radio-group v-model="form.supplier.store_type">-->
<!--                    <el-radio :label="10">{{$t('分店')}}</el-radio>-->
<!--                    <el-radio :label="20">{{$t('直营')}}</el-radio>-->
<!--                </el-radio-group>-->
<!--            </el-form-item>-->
<!--            <el-form-item :label="$t('菜品分类')" v-if="user_type==0">-->
<!--                <el-radio-group v-model="form.supplier.category_set" disabled>-->
<!--                    <el-radio :label="10">{{$t('同步主店')}}</el-radio>-->
<!--                    <el-radio :label="20">{{$t('分店创建')}}</el-radio>-->
<!--                </el-radio-group>-->
<!--                <div class="tips">{{$t('温馨提示：选择后，请勿随意修改，以免造成门店菜品数据错乱')}}</div>-->
<!--            </el-form-item>-->
<!--            <el-form-item :label="$t('绑定用户')">-->
<!--                <el-row>-->
<!--                    <el-button icon="el-icon-picture-outline" @click="userClick()">{{$t('选择用户')}}</el-button>-->
<!--                    <div v-if="form.supplier.user_id!=0" class="img">-->
<!--                        <span>{{$t('用户昵称')}}：{{ user_info.nickName }}</span>-->
<!--                        <img :src="user_info.avatarUrl" width="100" height="100"/>-->
<!--                    </div>-->
<!--                </el-row>-->
<!--            </el-form-item>-->
            <el-form-item :label="$t('地址')" prop="supplier.address" :rules="[{required: true,message: ' '}]">
                <el-input class="max-w460" v-model="form.supplier.address" :placeholder="$t('请输入地址')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('门店坐标')" prop="supplier.coordinate" :rules="[{required: true,message: ' '}]">
                <el-row class="mb16">
                    <el-col :span="24">
                        <el-input disabled v-model="form.supplier.coordinate" class="max-w460"></el-input>
                        <div class="form-item-hint">{{$t('在地图中点击确认位置，坐标自动填入')}}</div>
                    </el-col>
                </el-row>
                <el-row class="mb16">
                    <el-col :span="24" v-if="form.supplier.address">
                        <google-map ref="GoogleMap" gpsName="Positioning" :address="form.supplier.address" @setMap="setMap"></google-map>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item :label="$t('商家介绍')" prop="supplier.description">
                <el-input rows="6" type="textarea" v-model="form.supplier.description" class="max-w460"></el-input>
            </el-form-item>
            <el-form-item :label="$t('状态')" v-if="user_type==0&&form.supplier.is_main==0">
                <el-radio-group v-model="form.supplier.is_recycle">
                    <el-radio :label="0">{{$t('开启')}}</el-radio>
                    <el-radio :label="1">{{$t('禁止')}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('营业状态')">
                <el-radio-group v-model="form.supplier.status">
                    <el-radio :label="0">{{$t('营业中')}}</el-radio>
                    <el-radio :label="1">{{$t('停止营业')}}</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <!--上传图片组件-->
        <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">{{$t('上传图片')}}</Upload>
        <!--管理用户-->
        <GetUser :is_open="open_user" @close="closeDialogFunc($event, 'add')"></GetUser>
    </div>
</template>
<script>
import SupplierApi from '@/api/supplier.js';
import select_region from '@/utils/select.region.js';
import {formatModel} from '@/utils/base.js'
// import Getpoint from '@/components/map/Getpoint.vue';
import store from '@/store';
import bus from '@/utils/eventBus.js';

import Upload from '@/components/file/Upload';
import GetUser from '@/components/user/GetUser.vue';
import GoogleMap from '@/components/map/GoogleMap.vue';
import {submitResEnum} from "../../../logic/buildStore";

export default {
    name: "editStore",
    components: {
        Upload, GetUser, GoogleMap
    },
    data() {
        return {
            /*form表单数据*/
            form: {
                shop_supplier_id: 0,
                supplier: {
                    user_name: '',
                    logo: '',
                    business_id: 0,
                    name: '',
                    link_name: '',
                    link_phone: '',
                    address: '',
                    description: '',
                    user_id: 0,
                    store_type: 20,
                    coordinate: '',
                    province_id: '',
                    city_id: '',
                    region_id: '',
                    status: 0,
                    is_recycle: 0,
                    is_main: 1,
                    category_set: ''
                },
            },
            loading: false,
            /*是否上传图片*/
            isupload: false,
            type: 'logo',
            open_user: false,
            user_info: {},
            /*省市区*/
            areaList: select_region,
            user_type: ''
        }
    },
    async created() {
      await this.init();
        // bus.$on('updateStoreCallback', this.init)

    },
    beforeDestroy() {
        bus.$off('updateStoreCallback', this.init)
    },
    methods: {
        async init() {
            let id = localStorage.getItem('currentStore')
            if (id && Number(id)) {
                this.form.shop_supplier_id = id
            } else {
                localStorage.removeItem('currentStore')
                self.$message({
                    message:this.$t('获取当前门店失败，请刷新界面重试') ,
                    type: 'error'
                });
                return
            }
            await this.getData();
            await this.getBaseInfo();
        },
        async getBaseInfo() {
            let res = await store.dispatch('common/getBaseInfo');
            this.user_type = res.user.user_type;
        },
        /*获取参数*/
        async getData() {
            let self = this;
            let res = await SupplierApi.toEditSupplier({
                shop_supplier_id: self.form.shop_supplier_id
            }, true)
            if (res && res.code === 1) {
                self.form.supplier = formatModel(self.form.supplier, res.data.model);
                self.form.supplier.coordinate = res.data.model.latitude + ',' + res.data.model.longitude;
                if (res.data.model.superUser) {
                    self.form.supplier.user_name = res.data.model.superUser.user_name;
                }
                if (res.data.model.user) {
                    self.user_info.avatarUrl = res.data.model.user.avatarUrl;
                    self.user_info.nickName = res.data.model.user.nickName;
                }
            }
        },

        /*添加用户*/
        async onSubmit() {
            return new Promise(async (resolve) => {
                let self = this;
                let form = self.form;
                self.$refs.form.validate(async (valid) => {
                    if (valid) {
                        self.loading = true;
                        let res = await SupplierApi.editSupplier(form, true)
                        self.loading = false;
                        if (res && res.code == 1) {
                            // self.$message({
                            //     message: self.$t('恭喜你，门店修改成功'),
                            //     type: 'success'
                            // });
                            // self.$router.push('/supplier/supplier/index');
                            resolve(submitResEnum.success)
                        } else {
                            self.loading = false;
                            resolve(submitResEnum.submitFailed)
                        }
                    } else {
                        resolve(submitResEnum.invalidForm)
                    }
                });
            })
        },
        /*取消*/
        cancelFunc() {
            this.$router.back(-1);
        },
        /*打开弹出层*/
        userClick() {
            this.open_user = true;
        },
        /*上传*/
        openUpload(e) {
            this.type = e;
            this.isupload = true;
        },

        /*获取图片*/
        returnImgsFunc(e) {
            if (e != null && e.length > 0) {
                if (this.type == 'logo') {
                    this.form.supplier.logo = e[0].file_path;
                }
            }
            this.isupload = false;
        },
        /*关闭获取用户弹窗*/
        closeDialogFunc(e) {
            if (e.type != 'error') {
                this.user_info = e.params[0];
                this.form.supplier.user_id = e.params[0].user_id;
            }
            this.open_user = false;
        },
        /*获取经纬度*/
        getMapdataFunc(e) {
            this.form.supplier.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
        },
        /*选择的地址*/
        choseFunc(e) {
            this.form.supplier.coordinate = e.location.lat + ',' + e.location.lng;
            this.form.supplier.address = e.address;
        },
        /*初始化城市id*/
        initCity() {
            this.form.supplier.city_id = ''
        },

        /*初始化区id*/
        initRegion() {
            this.form.supplier.region_id = ''
        },

        //google
        setMap(info) {
            this.form.supplier.coordinate = info.lat + ',' + info.lng;
        }

    }
}
</script>
<style scoped lang="scss">
.tips {
    color: #FF0000;
}

.basic-setting-content {
}

.product-add {
    padding-bottom: 50px;
}

.img {
    margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/buildstore/basicInfo/editStore.vue